import { postEventSongEditGuest } from "../../../../helpers/event_helper.js";
import { eventSongEditSaving, eventSongEditSuccess, eventSongEditError } from "./reducer";

// song: { id } for a catalogue song, or { id: null, artistTitle } for one typed in.
export const updateEventSong = (id, guestId, song) => async (dispatch) => {
  try {
    dispatch(eventSongEditSaving());
    const data = await postEventSongEditGuest(id, { id: guestId, song });
    if (data) {
      dispatch(eventSongEditSuccess());
    }
  } catch (error) {
    // 422 validation errors arrive as a violations array, everything else as a string.
    const message = Array.isArray(error) ? error[0]?.message : error;
    dispatch(eventSongEditError(message));
  }
};
